import { useEffect, useRef } from 'react';
import { useAuth } from '@/hooks/useAuth';
import api from '@/lib/api';
import { toast } from 'sonner';

/**
 * Polls the user's earned badges. When a new one appears since the last check
 * (per user, tracked in localStorage), fires a celebratory toast.
 */
export default function BadgeWatcher() {
  const { user } = useAuth();
  const lastCodes = useRef(null);

  useEffect(() => {
    if (!user) return;
    const storageKey = `cx_badges_${user.user_id}`;
    lastCodes.current = new Set(JSON.parse(localStorage.getItem(storageKey) || '[]'));

    let alive = true;
    const check = async () => {
      try {
        const r = await api.get('/badges/mine');
        const badges = r.data.badges || [];
        const codesNow = new Set(badges.map(b => b.code));
        if (lastCodes.current) {
          for (const b of badges) {
            if (!lastCodes.current.has(b.code)) {
              toast.success(`Badge unlocked: ${b.label}`, {
                description: b.description,
                duration: 6000,
              });
            }
          }
        }
        localStorage.setItem(storageKey, JSON.stringify([...codesNow]));
        lastCodes.current = codesNow;
      } catch (_e) { /* ignore */ }
    };
    // First check after 3s (let page settle)
    const t = setTimeout(check, 3000);
    // Then poll every 45s
    const iv = setInterval(check, 45000);
    return () => { alive = false; clearTimeout(t); clearInterval(iv); };
  }, [user?.user_id]);

  return null;
}
